module.exports = __webpack_public_path__ + "img/img_a@2x.7128f246.png";